import styled from 'styled-components';
import { IconButton as MuiIconButton } from '@material-ui/core';

export const Button = styled(MuiIconButton).attrs({ size: 'small' })`
  color: #333 !important;

  svg {
    color: #333 !important;
  }

  :hover {
    color: currentColor !important;
    background-color: rgba(0, 0, 0, 0.04) !important;

    svg {
      color: #000 !important;
    }
  }
`;
